(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  function syncHeaderScrollShadow() {
    const wrapper = document.querySelector('.section-header .header-wrapper');
    if (!wrapper) return;
    const y = window.pageYOffset || document.documentElement.scrollTop || 0;
    wrapper.classList.toggle('header-wrapper--scrolled', y > 0);
  }

  function applyHeaderWhiteBgSectionClass() {
    const whiteHost = document.querySelector('[data-header-white-bg]');
    if (!whiteHost) return;
    const section = whiteHost.closest('.shopify-section.section-header');
    if (section) section.classList.add('section-header--white-bg');
  }

  document.addEventListener('DOMContentLoaded', () => {
    applyHeaderWhiteBgSectionClass();
    syncHeaderScrollShadow();
    window.addEventListener('scroll', syncHeaderScrollShadow, { passive: true });
    window.addEventListener('resize', syncHeaderScrollShadow, { passive: true });
  });
  window.addEventListener('load', syncHeaderScrollShadow);
  window.addEventListener('pageshow', syncHeaderScrollShadow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ritual-steps"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__ritualStepsStackBound) return;
  window.__ritualStepsStackBound = true;

  var ROOT = '[data-ritual-steps-stack]';
  var LAYER = '.ritual-steps__item';
  var PIN = '.ritual-steps__stack-pin'; 
  var TRACK = '.ritual-steps__track';
  /** When fully stacked, card j sits j * STACK_STEP_PX below the first card’s top (10px strip of each card below shows). */
  var STACK_STEP_PX = 10;
  var SCROLL_RANGE_DEFAULT = 3;
  var CLASS_STACK_FRONT = 'ritual-steps__item--stack-front';

  function clearStackFront(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.' + CLASS_STACK_FRONT).forEach(function (el) {
      el.classList.remove(CLASS_STACK_FRONT);
    });
  }

  function setStackFront(root, items, index) {
    var n = items && items.length ? items.length : 0;
    var j;
    for (j = 0; j < n; j++) {
      if (j === index) {
        items[j].classList.add(CLASS_STACK_FRONT);
      } else {
        items[j].classList.remove(CLASS_STACK_FRONT);
      }
    }
  }

  function updateStackFrontFromLayout(root, items) {
    var n = items.length;
    if (n === 0) return;
    if (n === 1) {
      setStackFront(root, items, 0);
      return;
    }
    var j;
    var minTop = Infinity;
    for (j = 0; j < n; j++) {
      var t0 = items[j].getBoundingClientRect().top;
      if (t0 < minTop) minTop = t0;
    }
    var bestJ = 0;
    for (j = 0; j < n; j++) {
      var t1 = items[j].getBoundingClientRect().top;
      if (t1 < minTop + 0.5 && j >= bestJ) bestJ = j;
    }
    setStackFront(root, items, bestJ);
  }

  function getScrollRangeMult(root) {
    if (!root || !root.getAttribute) return SCROLL_RANGE_DEFAULT;
    var v = parseFloat((root.getAttribute('data-rs-scroll-range') || '').toString().trim(), 10);
    if (!isFinite(v) || v < 0.5) return SCROLL_RANGE_DEFAULT;
    if (v > 12) return 12;
    return v;
  }

  var roots = [];
  var scheduled = false;
  var listenersAttached = false;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /** Scroll-stack animation matches theme mobile breakpoint (desktop = static list). */
  function isStackViewport() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  /** Progress [0,1] for segment s using weighted scroll range (linear in scroll). */
  function segmentProgress(tLinear, s, bounds) {
    var lo = bounds[s];
    var hi = bounds[s + 1];
    if (tLinear <= lo) return 0;
    if (tLinear >= hi) return 1;
    return (tLinear - lo) / (hi - lo);
  }

  function clearStack(root) {
    clearStackFront(root);
    root.querySelectorAll(LAYER).forEach(function (el) {
      el.style.transform = '';
    });
    root.style.minHeight = '';
    root.style.removeProperty('--rs-card-equal-height');
    root.removeAttribute('data-rs-pin-measured');
    root.style.removeProperty('--rs-pin-to-first-card-bottom');
    delete root._rsSegmentBounds;
    var trackClear = root.querySelector(TRACK);
    if (trackClear) trackClear.style.height = '';
  }

  function measure(root) {
    var scrollYMeasure = window.scrollY || document.documentElement.scrollTop || 0;
    var pin = root.querySelector(PIN);
    var track = root.querySelector(TRACK);
    var items = root.querySelectorAll('.ritual-steps__item');
    if (!pin || !track || items.length === 0) {
      root.removeAttribute('data-rs-pin-measured');
      root.style.removeProperty('--rs-pin-to-first-card-bottom');
      return;
    }

    if (!isStackViewport()) {
      root.classList.remove('ritual-steps--stack');
      clearStack(root);
      delete root._rsOffsets;
      delete root._rsStackScroll;
      delete root._rsFullTrackHeight;
      delete root._rsStackedTrackHeight;
      delete root._rsOuterTop;
      delete root._rsSegmentBounds;
      return;
    }

    root.querySelectorAll(LAYER).forEach(function (el) {
      el.style.transform = '';
    });
    root.style.removeProperty('--rs-card-equal-height');
    track.style.height = '';

    var cards = root.querySelectorAll('.ritual-steps__card');
    var maxH = 0;
    var ci;
    for (ci = 0; ci < cards.length; ci++) {
      var ch = cards[ci].offsetHeight;
      if (ch > maxH) maxH = ch;
    }
    if (maxH > 0) {
      root.style.setProperty('--rs-card-equal-height', maxH + 'px');
    }

    root._rsFullTrackHeight = track.offsetHeight;
    root._rsStackedTrackHeight = items[0].offsetHeight;
    root._rsOuterTop = root.getBoundingClientRect().top + scrollYMeasure;

    var pinRectForSticky = pin.getBoundingClientRect();
    var firstItemRectForSticky = items[0].getBoundingClientRect();
    var dToFirstBottom = firstItemRectForSticky.bottom - pinRectForSticky.top;
    root.style.setProperty('--rs-pin-to-first-card-bottom', dToFirstBottom + 'px');
    root.setAttribute('data-rs-pin-measured', '');

    var pinH = pin.offsetHeight;

    if (prefersReducedMotion()) {
      clearStackFront(root);
      root.classList.remove('ritual-steps--stack');
      root.removeAttribute('data-rs-pin-measured');
      root.style.removeProperty('--rs-pin-to-first-card-bottom');
      root.style.minHeight = pinH + 'px';
      root._rsOffsets = null;
      root._rsStackScroll = 0;
      return;
    }

    if (items.length < 2) {
      clearStackFront(root);
      root.classList.remove('ritual-steps--stack');
      root.removeAttribute('data-rs-pin-measured');
      root.style.removeProperty('--rs-pin-to-first-card-bottom');
      root.style.minHeight = pinH + 'px';
      root._rsOffsets = [0];
      root._rsStackScroll = 0;
      return;
    }

    root.classList.add('ritual-steps--stack');

    var fr = items[0].getBoundingClientRect();
    var offsets = [];
    var k;
    var maxOff = 0;
    for (k = 0; k < items.length; k++) {
      var tr = items[k].getBoundingClientRect();
      var off = tr.top - fr.top;
      offsets.push(off);
      if (off > maxOff) maxOff = off;
    }

    var scrollMult = getScrollRangeMult(root);
    root._rsOffsets = offsets;
    root._rsStackScroll = maxOff * scrollMult;
    var stackTail = (items.length - 1) * STACK_STEP_PX;
    root.style.minHeight = pinH + maxOff * scrollMult + stackTail + 'px';

    /* Weighted timeline: segment s (card s+1) gets (s+1) share of scroll — each next card needs more scroll. */
    var segCount = items.length - 1;
    var segBounds = [0];
    var sumW = 0;
    var si;
    for (si = 0; si < segCount; si++) {
      sumW += si + 1;
    }
    for (si = 0; si < segCount; si++) {
      segBounds.push(segBounds[segBounds.length - 1] + (si + 1) / sumW);
    }
    root._rsSegmentBounds = segBounds;
  }

  function updateStack() {
    scheduled = false;

    roots = roots.filter(function (r) {
      return r.isConnected;
    });

    if (roots.length === 0) return;

    if (!isStackViewport()) {
      roots.forEach(function (r) {
        if (r.isConnected) measure(r);
      });
      return;
    }

    if (prefersReducedMotion()) {
      roots.forEach(function (root) {
        if (root.isConnected) measure(root);
      });
      return;
    }

    var scrollY = window.scrollY || document.documentElement.scrollTop || 0;
    var i;
    var j;
    var root;
    var items;
    var outerTop;
    var stackScroll;
    var offsets;
    var track;
    var fullTrackH;
    var stackedTrackH;
    var pinEl;
    var trackH;

    for (i = 0; i < roots.length; i++) {
      root = roots[i];

      items = root.querySelectorAll('.ritual-steps__item');
      offsets = root._rsOffsets;
      stackScroll = root._rsStackScroll;

      if (!offsets || stackScroll === undefined || items.length === 0) {
        measure(root);
        offsets = root._rsOffsets;
        stackScroll = root._rsStackScroll;
      }

      if (!offsets || stackScroll <= 0) {
        for (j = 0; j < items.length; j++) {
          items[j].style.transform = '';
        }
        clearStackFront(root);
        track = root.querySelector(TRACK);
        if (track) track.style.height = '';
        continue;
      }

      outerTop = root._rsOuterTop != null ? root._rsOuterTop : root.getBoundingClientRect().top + scrollY;
      var tLinear = (scrollY - outerTop) / stackScroll;
      if (tLinear < 0) tLinear = 0;
      else if (tLinear > 1) tLinear = 1;

      var n = items.length;
      track = root.querySelector(TRACK);
      fullTrackH = root._rsFullTrackHeight;
      stackedTrackH = root._rsStackedTrackHeight;
      var stackOverlapTail = (n - 1) * STACK_STEP_PX;
      var stackedTrackEnd =
        stackedTrackH != null ? stackedTrackH + stackOverlapTail : null;
      if (
        track &&
        fullTrackH != null &&
        stackedTrackEnd != null &&
        fullTrackH > stackedTrackEnd
      ) {
        trackH = fullTrackH - (fullTrackH - stackedTrackEnd) * tLinear;
        track.style.height = trackH + 'px';
      } else if (track) {
        track.style.height = '';
      }

      pinEl = root.querySelector(PIN);
      if (pinEl && stackScroll > 0) {
        root.style.minHeight = pinEl.offsetHeight + stackScroll + 'px';
      }

      /*
       * Chain stacking: segment s moves card s+1; ps from weighted bounds (linear in scroll).
       * Track matches tLinear; each later segment has a larger share of [0,1].
       * At tLinear=1, card j is at -offsets[j] + j * STACK_STEP_PX.
       */
      var segments = n - 1;
      var bounds = root._rsSegmentBounds;
      if (!bounds || bounds.length !== segments + 1) {
        measure(root);
        bounds = root._rsSegmentBounds;
      }
      for (j = 0; j < n; j++) {
        if (j === 0) {
          items[j].style.transform = '';
          continue;
        }
        var Tj = 0;
        for (var s = 0; s < j; s++) {
          var ps = segmentProgress(tLinear, s, bounds);
          var step = offsets[s + 1] - offsets[s];
          Tj += -step * ps;
        }
        /* Stagger: each card rests j * STACK_STEP_PX lower than the first (10px of the card below peeks out). */
        Tj += j * STACK_STEP_PX * tLinear;
        items[j].style.transform = 'translate3d(0,' + Tj + 'px,0)';
      }

      updateStackFrontFromLayout(root, items);
    }
  }

  function scheduleUpdate() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(updateStack);
  }

  var onScroll = scheduleUpdate;
  var onResize = function () {
    roots.forEach(function (root) {
      if (root.isConnected) measure(root);
    });
    scheduleUpdate();
  };

  function attachGlobalListeners() {
    if (listenersAttached) return;
    listenersAttached = true;

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });

    var se = document.scrollingElement || document.documentElement;
    if (se) {
      se.addEventListener('scroll', onScroll, { passive: true });
    }

    if (window.visualViewport) {
      window.visualViewport.addEventListener('scroll', onScroll, { passive: true });
      window.visualViewport.addEventListener('resize', onResize, { passive: true });
    }
  }

  function detachGlobalListeners() {
    if (!listenersAttached) return;

    window.removeEventListener('scroll', onScroll, { passive: true });
    window.removeEventListener('resize', onResize, { passive: true });

    var se = document.scrollingElement || document.documentElement;
    if (se) {
      se.removeEventListener('scroll', onScroll, { passive: true });
    }

    if (window.visualViewport) {
      window.visualViewport.removeEventListener('scroll', onScroll, { passive: true });
      window.visualViewport.removeEventListener('resize', onResize, { passive: true });
    }

    listenersAttached = false;
  }

  function registerRoot(root) {
    if (roots.indexOf(root) !== -1) return;
    roots.push(root);
    measure(root);
    attachGlobalListeners();
    scheduleUpdate();
  }

  function unregisterRoot(root) {
    var idx = roots.indexOf(root);
    if (idx >= 0) roots.splice(idx, 1);
    root.classList.remove('ritual-steps--stack');
    clearStack(root);
    delete root._rsOffsets;
    delete root._rsStackScroll;
    delete root._rsFullTrackHeight;
    delete root._rsStackedTrackHeight;
    delete root._rsOuterTop;
    delete root._rsSegmentBounds;
    if (roots.length === 0) {
      detachGlobalListeners();
    }
  }

  function init(container) {
    var scope = container && container.querySelectorAll ? container : document;
    var nodes = scope.querySelectorAll ? scope.querySelectorAll(ROOT) : [];
    var i;
    if (container && container.matches && container.matches(ROOT)) {
      registerRoot(container);
    }
    for (i = 0; i < nodes.length; i++) {
      registerRoot(nodes[i]);
    }
    scheduleUpdate();
  }

  function teardown(container) {
    var scope = container && container.querySelectorAll ? container : null;
    if (!scope) return;
    scope.querySelectorAll(ROOT).forEach(unregisterRoot);
    if (container.matches && container.matches(ROOT)) {
      unregisterRoot(container);
    }
  }

  function boot() {
    init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    requestAnimationFrame(boot);
  }

  window.addEventListener('load', function () {
    roots.forEach(function (r) {
      if (r.isConnected) measure(r);
    });
    init();
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector && event.target.querySelector(ROOT)) {
      init(event.target);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target && event.target.querySelector) {
      teardown(event.target);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
